<div *ngIf="{vehicle: serviceLaneFacade.vehicle$ | async,
    appointment: serviceLaneFacade.selectedAppointment$ | async,
    hyundaiEnabled: hyundaiIntegrationEnabled$ | async,
    vehicleDiagnostics: vehicleDiagnostics$ | async,
    serviceVisitsByVinError: svcVehicleDiagnosticsRootFacade.serviceVisitsByVinError$ | async,
    workOrderId: serviceLaneFacade.workOrderId$ | async,
    gmSltData: gmSltData$ | async,
    dealerBac: serviceLaneFacade.dealerBac$ | async,
    maintenanceSource: maintenanceScheduleSource$ | async,
    serviceVisitRecord: serviceVisitRecord$ | async} as data">
  <div
    [ngClass]="{ 'verify-customer-disable-background': verifyCustomerRequired, 'verify-customer-blur': verifyCustomerRequired, 'ease-out-blur': !verifyCustomerRequired }">
    <svc-appointment-summary [vehicle$]="serviceLaneFacade.vehicle$"
      [appointment$]="serviceLaneFacade.selectedAppointment$" [associate$]="serviceLaneFacade.customerAssociate$"
      [address$]="serviceLaneFacade.customerAddress$" [appointmentDropdowns$]="serviceAppointmentDropdowns$"
      [vehicleDropdowns$]="serviceLaneDropdownFacade.vehicleDropdowns$"
      [toggleTireFinderWidgetValue]="toggleTireFinderWidget" (toggleTireFinder)="toggleTireFinder($event)">
    </svc-appointment-summary>
  </div>
  <div id="blurContainer"
    [ngClass]="{ 'verify-customer-blur': verifyCustomerRequired, 'ease-out-blur': !verifyCustomerRequired }"
    class="flex-col">
    <div class="flex flex-col h-14 sticky mt-6 bg-white z-auto rounded-lg shadow-lg justify-center">
      <div
        class="inline-flex flex-row px-3 mt-2 items-center place-content-between w-full overflow-x-auto overflow-hidden">

        <a id="crm-sales-planner-link" [routerLink]="['./line-items']"
          [ngClass]="{'text-black': toggleTireFinderWidget}">
          <button class="py-2 px-2 whitespace-nowrap" (click)="hideTireFinderIfEnabled()">
            <span class="text-base" style="font-family: 'Open Sans'"
              [ngClass]="{ selected: primaryRouteUrl === 'line-items' && !toggleTireFinderWidget, 'not-selected': primaryRouteUrl !== 'line-items' }">Line
              Items</span>
          </button>
        </a>

        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M0 12L4.28571 6L0 0H2.1L6.38571 6L2.1 12H0ZM5.1 12L9.38571 6L5.1 0H7.2L11.4857 6L7.2 12H5.1Z"
            fill="#BBBBBB" />
        </svg>

        <ng-container *ngIf="data?.vehicleDiagnostics && data?.vehicleDiagnostics?.enabled">
          <ng-container [ngSwitch]="oem">
            <a *ngSwitchCase="'GM'" id="sl-vehicle-diagnostic-link" [routerLink]="['./vehicle-diagnostics/gm']"
              [ngClass]="{'text-black': toggleTireFinderWidget}"
              [queryParams]="{ vin: data?.vehicle?.vin, dealerCountryCode: data?.vehicleDiagnostics?.dealerCountryCode }">
              <div class="relative">
                <button class="py-2 px-2 whitespace-nowrap" (click)="hideTireFinderIfEnabled()">
                  <span class="text-base" style="font-family: 'Open Sans'"
                    [ngClass]="{ selected: primaryRouteUrl === 'vehicle-diagnostics' && !toggleTireFinderWidget, 'not-selected': primaryRouteUrl !== 'vehicle-diagnostics', 'text-red': data?.serviceVisitsByVinError }">SAVI
                  </span>
                </button>
              </div>
            </a>
          </ng-container>

          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M0 12L4.28571 6L0 0H2.1L6.38571 6L2.1 12H0ZM5.1 12L9.38571 6L5.1 0H7.2L11.4857 6L7.2 12H5.1Z"
              fill="#BBBBBB" />
          </svg>
        </ng-container>

        <a id="sl-body-report" [routerLink]="['./body-report']" [queryParams]="{ workOrderId: data.workOrderId }"
          [ngClass]="{'text-black': toggleTireFinderWidget}">
          <button class="py-2 px-2" [ngClass]="{'-mt-1.5': primaryRouteUrl === 'body-report'}"
            (click)="hideTireFinderIfEnabled()">
            <span class="text-sm block mt-1 sm:text-base sm:flex sm:mt-0"
              [ngClass]="{ selected: primaryRouteUrl === 'body-report' && !toggleTireFinderWidget, 'not-selected': primaryRouteUrl !== 'body-report' }"
              style="font-family: 'Open Sans'">Body Report</span>
          </button>
        </a>

        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M0 12L4.28571 6L0 0H2.1L6.38571 6L2.1 12H0ZM5.1 12L9.38571 6L5.1 0H7.2L11.4857 6L7.2 12H5.1Z"
            fill="#BBBBBB" />
        </svg>

        <a id="sl-inspection-link" [routerLink]="['./inspection']" [queryParams]="{ workOrderId: data.workOrderId }"
          [ngClass]="{'text-black': toggleTireFinderWidget}">
          <button class="py-2 px-2" (click)="hideTireFinderIfEnabled()">
            <span class="text-base" style="font-family: 'Open Sans'"
              [ngClass]="{ selected: primaryRouteUrl === 'inspection' && !toggleTireFinderWidget, 'not-selected': primaryRouteUrl !== 'inspection' }">Inspection</span>
          </button>
        </a>

        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M0 12L4.28571 6L0 0H2.1L6.38571 6L2.1 12H0ZM5.1 12L9.38571 6L5.1 0H7.2L11.4857 6L7.2 12H5.1Z"
            fill="#BBBBBB" />
        </svg>

        <ng-container [ngSwitch]="oem">
          <!-- GM Menu -->
          <ng-container *ngSwitchCase="'GM'">
            <!-- Motor Mode -->
            <a *ngIf="data?.maintenanceSource === 'MOTOR'" id="sl-schedule-link"
              [ngClass]="{'text-black': toggleTireFinderWidget}" [routerLink]="['./oem-maintenance']"
              [queryParams]="{ vin: data?.vehicle?.vin, odometer: data?.appointment?.odometerIn || data?.vehicle?.currentMileage, transactionId: appointmentId, transactionType: 'SA', workOrderId: data?.workOrderId }">
              <button class="py-2 px-2" (click)="hideTireFinderIfEnabled()">
                <span class="text-base" style="font-family: 'Open Sans'"
                  [ngClass]="{ selected: primaryRouteUrl === 'oem-maintenance' && !toggleTireFinderWidget, 'not-selected': primaryRouteUrl !== 'oem-maintenance' }">Menu</span>
              </button>
            </a>

            <!-- Legacy Mode -->
            <a *ngIf="data?.maintenanceSource !== 'MOTOR'" id="sl-schedule-link"
              [ngClass]="{'text-black': toggleTireFinderWidget}" [routerLink]="['./menu/vehicle/', vehicleId]"
              [queryParams]="{ appointmentId: appointmentId, vehicleVin: data?.vehicle?.vin, vehicleYear: data?.vehicle?.year, vehicleOdometer: data?.vehicle?.currentMileage, oem: oem, transactionId: appointmentId, transactionType: 'serviceAppointment', vehicleId: vehicleId, odometer: data?.vehicle?.currentMileage }">
              <button class="py-2 px-2" (click)="hideTireFinderIfEnabled()">
                <span class="text-base" style="font-family: 'Open Sans'"
                  [ngClass]="{ selected: primaryRouteUrl === 'menu' && !toggleTireFinderWidget, 'not-selected': primaryRouteUrl !== 'menu' }">Menu</span>
              </button>
            </a>
          </ng-container>

          <!-- Hyundai Menu -->
          <ng-container *ngSwitchCase="'HYU'">
            <!-- Motor Mode -->
            <a *ngIf="data?.maintenanceSource === 'MOTOR'" id="sl-schedule-link"
              [ngClass]="{'text-black': toggleTireFinderWidget}" [routerLink]="['./oem-maintenance']"
              [queryParams]="{ vin: data?.vehicle?.vin, odometer: data?.appointment?.odometerIn || data?.vehicle?.currentMileage, transactionId: appointmentId, transactionType: 'SA', workOrderId: data?.workOrderId }">
              <button class="py-2 px-2" (click)="hideTireFinderIfEnabled()">
                <span class="text-base" style="font-family: 'Open Sans'"
                  [ngClass]="{ selected: primaryRouteUrl === 'oem-maintenance' && !toggleTireFinderWidget, 'not-selected': primaryRouteUrl !== 'oem-maintenance' }">Menu</span>
              </button>
            </a>

            <!-- Legacy Mode -->
            <a *ngIf="data?.maintenanceSource !== 'MOTOR'" id="sl-schedule-link"
              [ngClass]="{'text-black': toggleTireFinderWidget}"
              [routerLink]="[data?.hyundaiEnabled?.integrationEnabled == '1' && data?.hyundaiEnabled?.menuEnabled == '1' ? './menu/hyundai/vehicle/' + vehicleId : './menu/vehicle/' + vehicleId]"
              [queryParams]="{ appointmentId: appointmentId, vehicleVin: data?.vehicle?.vin, vehicleYear: data?.vehicle?.year, vehicleOdometer: data?.vehicle?.currentMileage, oem: (data?.hyundaiEnabled?.integrationEnabled == '1' && data?.hyundaiEnabled?.menuEnabled == '1' ? oem : null), transactionId: appointmentId, transactionType: 'serviceAppointment', vehicleId: vehicleId, odometer: data?.vehicle?.currentMileage }">
              <button class="py-2 px-2" (click)="hideTireFinderIfEnabled()">
                <span class="text-base" style="font-family: 'Open Sans'"
                  [ngClass]="{ selected: primaryRouteUrl === 'menu' && !toggleTireFinderWidget, 'not-selected': primaryRouteUrl !== 'menu' }">Menu</span>
              </button>
            </a>
          </ng-container>

          <!-- Toyota Menu -->
          <ng-container *ngSwitchCase="'TOY'">
            <!-- Motor Mode -->
            <a *ngIf="data?.maintenanceSource === 'MOTOR'" id="sl-schedule-link"
              [ngClass]="{'text-black': toggleTireFinderWidget}" [routerLink]="['./oem-maintenance']"
              [queryParams]="{ vin: data?.vehicle?.vin, odometer: data?.appointment?.odometerIn || data?.vehicle?.currentMileage, transactionId: appointmentId, transactionType: 'SA', workOrderId: data?.workOrderId }">
              <button class="py-2 px-2" (click)="hideTireFinderIfEnabled()">
                <span class="text-base" style="font-family: 'Open Sans'"
                  [ngClass]="{ selected: primaryRouteUrl === 'oem-maintenance' && !toggleTireFinderWidget, 'not-selected': primaryRouteUrl !== 'oem-maintenance' }">Menu</span>
              </button>
            </a>

            <!-- Legacy Mode -->
            <a *ngIf="data?.maintenanceSource !== 'MOTOR'" id="sl-schedule-link" [routerLink]="['./service-schedule']"
              [ngClass]="{'text-black': toggleTireFinderWidget}"
              [queryParams]="{ appointmentId: appointmentId, oem: oem, transactionId: appointmentId, transactionType: 'serviceAppointment', vehicleId: vehicleId, odometer: data?.vehicle?.currentMileage }">
              <button class="py-2 px-2" (click)="hideTireFinderIfEnabled()">
                <span class="text-base" style="font-family: 'Open Sans'"
                  [ngClass]="{ selected: primaryRouteUrl === 'service-schedule' && !toggleTireFinderWidget, 'not-selected': primaryRouteUrl !== 'service-schedule' }">Menu</span>
              </button>
            </a>
          </ng-container>

          <!-- Default Menu (all other OEMs) -->
          <ng-container *ngSwitchDefault>
            <!-- Motor Mode -->
            <a *ngIf="data?.maintenanceSource === 'MOTOR'" id="sl-schedule-link"
              [ngClass]="{'text-black': toggleTireFinderWidget}" [routerLink]="['./oem-maintenance']"
              [queryParams]="{ vin: data?.vehicle?.vin, odometer: data?.appointment?.odometerIn || data?.vehicle?.currentMileage, transactionId: appointmentId, transactionType: 'SA', workOrderId: data?.workOrderId }">
              <button class="py-2 px-2" (click)="hideTireFinderIfEnabled()">
                <span class="text-base" style="font-family: 'Open Sans'"
                  [ngClass]="{ selected: primaryRouteUrl === 'oem-maintenance' && !toggleTireFinderWidget, 'not-selected': primaryRouteUrl !== 'oem-maintenance' }">Menu</span>
              </button>
            </a>

            <!-- Legacy Mode -->
            <a *ngIf="data?.maintenanceSource !== 'MOTOR'" id="sl-schedule-link"
              [routerLink]="['./menu/vehicle/', vehicleId]" [ngClass]="{'text-black': toggleTireFinderWidget}"
              [queryParams]="{ appointmentId: appointmentId, oem: oem, transactionId: appointmentId, transactionType: 'serviceAppointment', vehicleId: vehicleId, odometer: data?.vehicle?.currentMileage }">
              <button class="py-2 px-2" (click)="hideTireFinderIfEnabled()">
                <span class="text-base" style="font-family: 'Open Sans'"
                  [ngClass]="{ selected: primaryRouteUrl === 'menu' && !toggleTireFinderWidget, 'not-selected': primaryRouteUrl !== 'menu' }">Menu</span>
              </button>
            </a>
          </ng-container>
        </ng-container>

        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M0 12L4.28571 6L0 0H2.1L6.38571 6L2.1 12H0ZM5.1 12L9.38571 6L5.1 0H7.2L11.4857 6L7.2 12H5.1Z"
            fill="#BBBBBB" />
        </svg>

        <a id="sl-confirmation-link" [routerLink]="['./confirmation']"
          [ngClass]="{'text-black': toggleTireFinderWidget}">
          <button class="py-2 px-2" (click)="refreshQuoteLines(); hideTireFinderIfEnabled()">
            <span class="text-base" style="font-family: 'Open Sans'"
              [ngClass]="{ selected: primaryRouteUrl === 'confirmation' && !toggleTireFinderWidget, 'not-selected': primaryRouteUrl !== 'confirmation' }">Confirmation</span>
          </button>
        </a>
      </div>
    </div>

    <div [hidden]="toggleTireFinderWidget">
      <router-outlet></router-outlet>
    </div>
    <div class="widget-container h-full w-full pt-4" [hidden]="!toggleTireFinderWidget">
      <!-- Widget will be dynamically inserted here -->
    </div>
  </div>